(function (ebusy, $) {

	ebusy.lite = ebusy.lite || {};
	
	ebusy.lite.createPlayerResolver = function(urlResolver, nameInput, maxResults) {

		var currentXhr     = null;
		var debounceTimer  = null;

		var cancelPendingSearch = function() {
			clearTimeout(debounceTimer);
			debounceTimer = null;

			if (currentXhr) {
				currentXhr.abort();
				currentXhr = null;
			}
		};

		// search players — debounced, with XHR abort so only one in-flight request exists at a time.
		// Twitter Typeahead's internal asyncResults callback already guards against stale responses
		// (it becomes a no-op when a newer query has been started), so no extra sequence counter needed.
		var players = function(query, syncResults, asyncResults) {

			cancelPendingSearch();
			debounceTimer = setTimeout(function() {
				debounceTimer = null;
				currentXhr = $.get(urlResolver(), { query: query }, function(result) {
					currentXhr = null;
					$("#no-results").toggleClass("d-none", result.players.length > 0);
					$("#too-many-results").toggleClass("d-none", result.players.length <= maxResults);
					asyncResults(result.players);
				});
			}, 800);
		};
		
		// build typeahead
		$(nameInput).typeahead({
			minLength: 2,
			highlight: false,
			hint: false,
			classNames: {
				input: 'form-control'
			}
		}, {
			limit: maxResults,
			name: 'players',
			display: 'name',
			source: players
		});
		
		// fix twitter css
		$(".twitter-typeahead").css("display", "inline");
		
		// custom suggestion rendering
		$(nameInput).bind('typeahead:render', function(ev, suggestions, async, dataset) {
			$("#cards-content").empty();
			$("#cards").toggleClass("d-none", suggestions.length == 0);
			$(".actions").addClass("d-none");
			
			for(i in suggestions) {
				var suggestion = suggestions[i];
				var html = "<div class='col-sm-4 mb-1' id='resolved-player-" + i + "' data-resolved-user-id='" + suggestion.id + "' data-resolved-player-id='" + suggestion.playerId + "'><div class='card'><div class='card-block'><h5 class='card-header'>" + (suggestion.pseudonym  ? suggestion.pseudonym : ((suggestion.title ? suggestion.title : '') + " " + suggestion.firstname + " " + suggestion.lastname)) + "</h5></div></div></div>";
				$("#cards-content").html($("#cards-content").html() + html);
			}

			$(document).trigger("resolved-player:render", suggestions);
			
			$("[id^='resolved-player-']").css("cursor", "pointer");
		});
		
		$(document).on("input keydown change", nameInput, function() {
			if($(nameInput).val() == '') {
				cancelPendingSearch();
				$("#too-many-results").addClass("d-none");
				$("#no-results").addClass("d-none");
				$("#cards-content").empty();
				$("#cards").addClass("d-none");
				$(".actions").removeClass("d-none");
			}
		});
		
		return {
			click: function(onClick) {
				$(document).on("click", "[id^='resolved-player-']", function() {
					cancelPendingSearch();
					$(nameInput).val($(this).text().trim());
					$("#cards-content").empty();
					$("#too-many-results").addClass("d-none");
					$("#cards").addClass("d-none");
					$(".actions").removeClass("d-none");
					onClick($(this).data("resolved-user-id"), $(this).data("resolved-player-id"));
				});
				
				return this;
			},
			
			render: function(onRender) {
				$(document).on("resolved-player:render", function(ev, players) {
					onRender(players);
				});
				
				return this;
			}
		};
	};

})(window.ebusy = window.ebusy || {}, window.jQuery);
